import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  async connect() {
    const currentTab = this.element.querySelector("[aria-current='page']");

    if (currentTab) {
      const lib = await import('scroll-into-view-if-needed');
      const scrollIntoView = lib.default;
      scrollIntoView(currentTab, { inline: 'center', boundary: this.element });
    }
  }
}
